import { InfoWrapper, Wrapper } from "./styles";
import { QueueInformation } from "views/components/QueueInformation";
import { Spin } from "antd";
import { TicketVideoCall } from "views/components/TicketVideoCall";
import { WaitingRoomHeader } from "views/components/WaitingRoomHeader";
import { fetchAttentionTurn, fetchTicketQR } from "network/requests";
import { getPeopleAhead } from "lib/helpers/getPeopleAhead";
import { getWaitStimated } from "lib/getWaitStimated";
import { pathOr } from "ramda";
import { selectLine } from "state/lines/selectors";
import { selectOffice } from "state/offices/selectors";
import { setGlobal, useDispatch, useGlobal } from "reactn";
import { useHistory, useParams } from "react-router-dom";
import { useJoinWs } from "hooks/useJoinWs";
import { waitingRoomThemes } from "./themes";
import React, { useEffect, useState } from "react";
export const WaitingRoom = () => {
	const { officeSlug, lineSlug, ticketId } = useParams();
	const getLines = useDispatch("requestLines");
	const getOffice = useDispatch("requestOffice");
	const [lines] = useGlobal("linesv2");
	const [user] = useGlobal("user");
	const [newTicket] = useGlobal("newTicket");
	const [offices] = useGlobal("officesv2");
	const [loading, setLoading] = useState(false);
	const history = useHistory();
	const [ticketInfo, setTicketInfo] = useState({
		ticket: null,
		loading: true,
		error: false,
	});
	const token = pathOr("", ["token"], user);
	const [isTicketAttentionInitiated, setIsTicketAttentionInitiated] =
		useState(false);
	const [lastTicketCalled, setLastTicketCalled] = useState("");

	const line = selectLine(lines, lineSlug);
	const office = selectOffice(offices, officeSlug);

	const averageElapsed = pathOr(
		0,
		["line", "raw_tickets", "average_elapsed", "mean"],
		line
	);

	const ticketNumber = pathOr(null, ["ticket", "number"], ticketInfo);
	const currentTicket = pathOr(null, ["call", "number"], line);
	const inserted_at = pathOr(null, ["call", "inserted_at"], line);

	const officeTheme = pathOr("zeroq", ["options", "theme"], office);
	const isBetaMeetActive = pathOr(
		false,
		["options", "betaMeetIsActive"],
		office
	);

	const lineQueue = pathOr(0, ["raw_tickets", "queue"], line);

	const handlePeopleAhead = async () => {
		if (loading) return;

		setLoading(true);
		const res = await fetchAttentionTurn({
			id: ticketId,
			type: "ticket",
			token,
		});
		setLoading(false);
		if (
			(res.cuid && !res.hasFinishedAttention) ||
			(!lineQueue &&
				res.hasOwnProperty("hasFinishedAttention") &&
				!res.hasFinishedAttention)
		) {
			localStorage.setItem("virtualRoomLastTicket", ticketId);
			setIsTicketAttentionInitiated(true);
		}
		if (res.cuid && res.hasFinishedAttention) {
			history.go(-1);
		}
	};

	const peopleAhead = getPeopleAhead(
		ticketNumber,
		currentTicket,
		inserted_at
	);

	const waitTime = getWaitStimated(peopleAhead, averageElapsed);
	useEffect(() => {
		setGlobal({ UIConfig: { hideFooter: true, hideHeader: true } });

		return () => {
			setGlobal({ UIConfig: { hideFooter: false, hideHeader: false } });
		};
	}, []);

	const themeToUse =
		waitingRoomThemes[officeTheme] || waitingRoomThemes.zeroq;

	const { join } = useJoinWs();

	useEffect(() => {
		join(officeSlug);
	}, [join, officeSlug]);

	useEffect(() => {
		getOffice({ officeSlug });

		getLines({ officeSlug });
	}, [getLines, getOffice, officeSlug]);

	useEffect(() => {
		if (!ticketId) return;

		const interval = setInterval(() => {
			handlePeopleAhead();
		}, 30000);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ticketId]);

	useEffect(() => {
		setGlobal({
			newTicket: {
				...newTicket,
				didFinish: false,
			},
		});
	}, []);

	useEffect(() => {
		fetchTicketQR(ticketId)
			.then((res) => {
				setTicketInfo({
					ticket: res,
					loading: false,
					error: false,
				});
			})
			.catch((err) => {
				setTicketInfo({
					ticket: null,
					loading: false,
					error: true,
				});
			});
	}, [ticketId]);

	useEffect(() => {
		if (peopleAhead === 0) {
			localStorage.setItem("virtualRoomLastTicket", ticketId);
		}
	}, [peopleAhead, ticketId]);

	useEffect(() => {
		if (line && lineQueue === 0 && ticketId) {
			handlePeopleAhead();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lineQueue, ticketId, line]);

	useEffect(() => {
		setLastTicketCalled(
			localStorage.getItem("virtualRoomLastTicket") || ""
		);
	}, []);

	return (
		<Wrapper>
			{!office ? (
				<Spin />
			) : (
				<>
					<WaitingRoomHeader theme={themeToUse} />
					<InfoWrapper>
						{!ticketInfo.loading ? (
							isTicketAttentionInitiated ? (
								<TicketVideoCall
									ticketId={ticketId}
									theme={themeToUse}
									lastTicketCalled={lastTicketCalled}
									isBetaMeetActive={isBetaMeetActive}
									token={token}
									officeSlug={officeSlug}
									office={office}
								/>
							) : (
								<QueueInformation
									peopleInQueue={peopleAhead}
									waitTime={waitTime}
									theme={themeToUse}
									office={office}
								/>
							)
						) : (
							<Spin />
						)}
					</InfoWrapper>
				</>
			)}
		</Wrapper>
	);
};

export default WaitingRoom;
